import { TFunction } from 'react-i18next';

import { TOptions } from 'i18next';

export function getMappedTranslation<
    MapKeyType extends number | string | symbol
>(
    map: Partial<Record<MapKeyType | '', string>>,
    value: MapKeyType | undefined,
    t: TFunction,
    fallback?: string,
    options?: TOptions
) {
    const key = map[value ?? ''];

    if (key) {
        return t(key, options);
    }

    return fallback ? t(fallback, options) : '';
}
